import MainLayout from 'src/layouts';
import ListPorts from 'src/features/ListPorts';
import { Helmet } from 'react-helmet';

const PortsPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Ports Information</title>
      </Helmet>
      <ListPorts />
    </MainLayout>
  );
};

export default PortsPage;
